import React from 'react';
import styles from './modalheader.module.scss';

interface Props {
  title: string;
  onCloseClick?: () => void;
}

const ModalHeader = ({ title, onCloseClick }: Props) => {
  return (
    <div className={`modal-header ${styles.header}`}>
      <h5 className={`modal-title ${styles.title}`}>
        {title}
      </h5>
      {onCloseClick &&
        <button type="button" className={`close ${styles.closeBtn}`} onClick={onCloseClick}>
          <span aria-hidden="true">&times;</span>
        </button>
      }
    </div>
  )
}

export default ModalHeader;
